// extracted by mini-css-extract-plugin
module.exports = {"camsReportsMenu":"CamsReportsMenu_camsReportsMenu__3bav8"};